import { ApolloClient, InMemoryCache } from '@apollo/client';

const token = localStorage.getItem('jwt');

const client = new ApolloClient({
  uri: 'https://vibecat.me/graphql',
  cache: new InMemoryCache({
    typePolicies: {
      // Apply a default policy for all types
      defaultTypePolicy: {
        fields: {
          // Apply a default merge function for all fields
          defaultFieldPolicy: {
            merge: (existing, incoming) => {
              return incoming; // Always use incoming data
            },
          },
        },
      },
    },
  }),
  headers: token ? {
    Authorization: `Bearer ${token}`
  } : {}
});


client.hasAuthenticationToken = function() {
  return this.link.options.headers && !!this.link.options.headers.Authorization;
};

export default client;
